import { Database } from "lucide-react";
import { cn } from "@/lib/utils";

// The server already sanitizes the logo; only inline images or https URLs reach the <img> here too.
export function safeIconUrl(url: string | null | undefined) {
  const value = url?.trim();
  if (!value) return null;
  const lower = value.toLowerCase();
  return lower.startsWith("data:image/") || lower.startsWith("https://") ? value : null;
}

interface Props {
  iconUrl?: string | null;
  // Frame (size, border, background). The logo and the fallback are centered in it.
  className?: string;
  imageClassName?: string;
  fallbackClassName?: string;
}

// Connector logo, or the generic database icon when the connector has none.
export default function ConnectorIcon({ iconUrl, className, imageClassName, fallbackClassName }: Props) {
  const src = safeIconUrl(iconUrl);
  return (
    <span className={cn("flex shrink-0 items-center justify-center overflow-hidden", className)}>
      {src
        ? <img src={src} alt="" className={cn("object-contain", imageClassName)} loading="lazy" decoding="async" referrerPolicy="no-referrer" draggable={false} />
        : <Database className={fallbackClassName} aria-hidden />}
    </span>
  );
}
